module.exports = __webpack_public_path__ + "img/RIGID PGG KNUCKLE CRANE TRUCK_RHD_THUMB.e637130b.jpg";